import { writable } from "svelte/store";
const completedLessons = writable([]);
export default completedLessons;
